module.exports = __webpack_public_path__ + "static/borrowBannerMobile-147ea8d55b37213f7a4981aef67a12aa.png";